import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

// Serial numbers of one movement line: at most 4 tags, "+N more" opens the
// whole list inline. With [summary]="true" only "N serial numbers" and the report link render.
// A serialized product without serials gets a muted note.
@Component({
  selector: 'app-serial-tags',
  templateUrl: './serial-tags.component.html',
  styleUrls: ['./serial-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SerialTagsComponent {
  @Input() serials: string[] | null | undefined;
  @Input() serialized: boolean = false;
  @Input() kind: 'pick' | 'receive' = 'pick';
  @Input() summary: boolean = false;
  @Input() prdID: number | null | undefined;
  @Input() productName: string | null | undefined;
  @Output() reportOpen = new EventEmitter<void>();

  readonly maxTags = 4;
  open = false;
  copied = false;

  constructor(private _router: Router, private _cdr: ChangeDetectorRef,
              private _toastr: ToastrService, private _translate: TranslateService) {}

  copyAll(): void {
    const text = (this.serials || []).join('\n');
    const ok = () => {
      this.copied = true;
      this._cdr.markForCheck();
      this._toastr.success(this._translate.instant('serials.copied'));
      setTimeout(() => { this.copied = false; this._cdr.markForCheck(); }, 2000);
    };
    const fail = () => this._toastr.error(this._translate.instant('serials.copyFailed'));
    const fallback = () => (this.legacyCopy(text) ? ok() : fail());
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(ok, fallback);
    } else {
      fallback();
    }
  }

  private legacyCopy(text: string): boolean {
    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    let done = false;
    try { done = document.execCommand('copy'); } catch { done = false; }
    document.body.removeChild(el);
    return done;
  }

  openReport(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.reportOpen.emit();
    this._router.navigate(['/reports/serialized'], {
      queryParams: { productId: this.prdID, ...(this.productName ? { productName: this.productName } : {}) }
    });
  }
}
